<template>
    <!-- #5DD7FF -->
    <div class="line">
        <!-- 小题内容开始 -->
        <div class="line-wrap clearfix"
             :id="'canvasWrap'+pageAsk.id+pageTag">
            <canvas :id="'canvas'+pageAsk.id+pageTag"></canvas>
            <!-- <div class="line-left">
        <template v-for="option in pageAsk.options">
          <div class="line-option" v-if='option.link_id >= 0' :id="'optionLeft'+option.id+pageTag"
               @click="chooseLeft(pageAsk.id,option.id)">
            <span v-html="option.content"></span>
            <img v-if="option.image" :src="option.image" alt="">
          </div>
        </template>
      </div>
      <div class="line-right">
        <template v-for="option in pageAsk.options">
          <div class="line-option" v-if='option.link_id < 0' :id="'optionRight'+pageAsk.id+option.index+pageTag"
               @click="chooseRight(pageAsk.id,option.index)">
            <span v-html="option.content"></span>
            <img v-if="option.image" :src="option.image" alt="">
          </div>
        </template>
      </div> -->
            <div class="line-left">
                <template v-for="option,i in pageAsk.options">
                    <!-- @click="chooseLeft(pageAsk.id,option.index)" -->
                    <div :class="{'line-option': true,'inspect_myColor':myColor,'gray':onlyshow && result==1, 'blue':onlyshow && result!=1}"
                         v-if='option.link_id < 0'
                         :id="'optionLeft'+pageAsk.id+option.index+pageTag"
                         v-tap="{ methods:chooseLeft, index : option.index, askId: pageAsk.id}"
                         :key="option.id"
                         :attr-id='i'>
                        <span v-html="option.content"></span>
                        <img v-if="option.image"
                             :src="option.image"
                             alt="">
                        <i class="dot"></i>
                    </div>
                </template>
            </div>
            <div class="line-right">
                <template v-for="option in pageAsk.options">
                    <!-- @click="chooseRight(pageAsk.id,option.id)" -->
                    <div :class="{'line-option': true,'inspect_myColor':myColor,'gray':onlyshow && result==1, 'blue':onlyshow && result!=1}"
                         v-if='option.link_id >= 0'
                         :id="'optionRight'+option.id+pageTag"
                         v-tap="{ methods:chooseRight , id : option.id, askId: pageAsk.id}"
                         :key="option.id"
                         :attr-id='option.id'>
                        <span v-html="option.content"></span>
                        <img v-if="option.image"
                             :src="option.image"
                             alt="">
                        <i class="dot"></i>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    data () {
        return {
            onlyShowAnswer: false,
            hasEqual: false,
            oldTarget: null,
            resultArray: []
        }
    },
    // 父组件通过ask字段 传给子组件当前题目的数据
    // sheet是用户答案
    // onlyshow 是否可操作
    // tag 每个连线实体的标记，为结果展示同ID试题做的标记
    computed: {
        pageAsk () {
            return this.ask
        },
        pageTag () {
            return this.tag ? this.tag : ''
        },
        lineColor () {
            if (this.myColor) {
                return '#5d89ef';
            } else {
                return (this.result == 0 ? 'red' : '#5DD7FF')
            }

            // return (this.result == 1 ? 'hsl(0,0%,80%)' : 'hsl(195,100%,68%)')
        }
    },
    props: ['ask', 'sheet', 'onlyshow', 'tag', 'result', 'myColor'],
    watch: {
        // 检测到ask变化，那就重绘整个页面
        ask () {
            this.initData();
            this.$nextTick(function () {
                this.initCanvas()
            })
        }
    },
    methods: {
        setOptionHeight () {
            let leftOptionWrap = document.querySelector(".line-left");
            let leftOptoin = leftOptionWrap.querySelectorAll(".line-option");
            let rightOptionWrap = document.querySelector(".line-right");
            let rightOptoin = rightOptionWrap.querySelectorAll(".line-option");
            for (let i = 0; i < leftOptoin.length; i++) {
                if (leftOptoin[i].clientHeight > this.leftHeight) {
                    this.leftHeight = leftOptoin[i].clientHeight
                }
            }
            for (let i = 0; i < rightOptoin.length; i++) {
                if (rightOptoin[i].clientHeight > this.rightHeight) {
                    this.rightHeight = rightOptoin[i].clientHeight
                }
            }
        },
        leftEqRight () {
            // 判断左右个数是否一样
            let left = 0, right = 0;
            this.pageAsk.options.forEach(option => {
                if (option.link_id < 0) {
                    option.index = right;
                    right++;
                } else {
                    left++;
                }
            });
            return left == right;
        },
        chooseLeft ({ askId, index }) {
            if (this.onlyShowAnswer) return false;
            // 获取选项的当前dom
            let target = document.getElementById('optionLeft' + askId + index + this.pageTag);
            if (!target) return false;

            if (!this.onlyshow) {
                if (!this.hasEqual && this.oldTarget) {
                    let hasLined = this.resultArray.some(v => {
                        let val = this.oldTarget.getAttribute('attr-id')
                        let left = v.split('-')[1]
                        let right = v.split('-')[0]
                        return left == val || right == val
                    })
                    if (hasLined) {
                        this.oldTarget.getElementsByClassName('dot')[0].style.backgroundColor = '#5dd6ff';
                    } else {
                        this.oldTarget.getElementsByClassName('dot')[0].style.backgroundColor = '#ccc';
                    }
                }
                target.getElementsByClassName('dot')[0].style.backgroundColor = '#ffbc09';
            }

            let canvasObject = this.pageAsk.canvas;
            // canvasObject.right = {target, index};
            canvasObject.left = { target, index };
            this.hasEqual = false;
            if (canvasObject.right && canvasObject.left) {
                this.makeObject(askId);
                this.hasEqual = true;
            }
            if (!this.onlyshow && canvasObject.left) {
                this.oldTarget = canvasObject.left.target;
            }
        },
        chooseRight ({ askId, id }) {
            if (this.onlyShowAnswer) return false;
            // 获取选项的当前dom
            let target = document.getElementById('optionRight' + id + this.pageTag);
            if (!target) return false;
            if (!this.onlyshow) {
                if (!this.hasEqual && this.oldTarget) {
                    let hasLined = this.resultArray.some(v => {
                        let val = this.oldTarget.getAttribute('attr-id')
                        let left = v.split('-')[1]
                        let right = v.split('-')[0]
                        return left == val || right == val
                    })
                    if (hasLined) {
                        this.oldTarget.getElementsByClassName('dot')[0].style.backgroundColor = '#5dd6ff';
                    } else {
                        this.oldTarget.getElementsByClassName('dot')[0].style.backgroundColor = '#ccc';
                    }
                }
                target.getElementsByClassName('dot')[0].style.backgroundColor = '#ffbc09';
            }
            let canvasObject = this.pageAsk.canvas;
            // canvasObject.left = {target, id};
            canvasObject.right = { target, id };
            this.hasEqual = false;
            if (canvasObject.right && canvasObject.left) {
                this.makeObject(askId);
                this.hasEqual = true;
            }
            if (!this.onlyshow && canvasObject.right) {
                this.oldTarget = canvasObject.right.target;
            }
        },
        makeObject (askId) {
            let canvasObject = this.pageAsk.canvas;
            let _o = {};//左侧和右侧dom节点的x,y坐标
            // let to = canvasObject.right.index;//右侧的索引值
            let to = canvasObject.left.index;
            if (this.pageAsk.equal) {
                // 如果左边和右边的相等，那必须是一一对应的
                // 所以需将已经选中右侧的lineId删除
                for (let k in canvasObject.lineId) {
                    if (canvasObject.lineId[k].to == to) {
                        delete canvasObject.lineId[k];
                        break;
                    }
                }
            }
            // _o[canvasObject.left.id] = {...this.getLeftPos(canvasObject.left.target), ...this.getRightPos(canvasObject.right.target), ...{to}};
            _o[canvasObject.right.id] = { ...this.getRightPos(canvasObject.right.target), ...this.getLeftPos(canvasObject.left.target), ...{ to } };
            canvasObject.lineId = { ...canvasObject.lineId, ..._o };
            canvasObject.left = null;
            canvasObject.right = null;
            this.drawCanvas(askId);
        },
        drawCanvas (askId) {
            let canvasObject = this.pageAsk.canvas.lineId;
            let myCanvas = document.getElementById('canvas' + askId + this.pageTag);
            let context = myCanvas.getContext("2d");
            myCanvas.width = myCanvas.width
            context.strokeStyle = this.lineColor;//线颜色
            context.lineWidth = 2;//设置线宽
            let resultArray = [];
            for (let key in canvasObject) {
                let obj = canvasObject[key];
                context.moveTo(obj.x, obj.y);
                context.lineTo(obj.lx, obj.ly);
                resultArray.push(`${key}-${obj.to}`);
            }
            context.stroke();//画线框
            let _o = {
                askid: askId,
                result: resultArray.join('|'),
                askindex: this.pageAsk.a_no
            };
            this.resultArray = resultArray;
            if (!this.onlyshow) this.$emit('myResult', _o);
            if (!this.onlyshow) {
                // 去掉其他线外选中样式
                // let options = document.getElementById('q'+askId).querySelectorAll('.line-option');
                let options = document.querySelectorAll('.line-option');
                for (let i = 0; i < options.length; i++) {
                    options[i].querySelector('.dot').style.backgroundColor = '#ccc';
                }
                let rightOption = this.pageAsk.options.filter(v => v.link_id >= 0);
                let leftOption = this.pageAsk.options.filter(v => v.link_id < 0);
                for (let k in canvasObject) {
                    rightOption.forEach((option, i) => {
                        if (option.id == k) {
                            document.getElementById('canvasWrap' + askId).querySelectorAll('.line-right .line-option')[i].querySelector('.dot').style.backgroundColor = '#5dd6ff';
                            // document.querySelectorAll('.line-right .line-option')[i].querySelector('.dot').style.backgroundColor = '#5dd6ff';
                        }
                    })
                    let to = canvasObject[k].to; // 左侧选中索引
                    document.getElementById('canvasWrap' + askId).querySelectorAll('.line-left .line-option')[to].lastChild.style.backgroundColor = '#5dd6ff';
                    // document.querySelectorAll('.line-left .line-option')[to].lastChild.style.backgroundColor = '#5dd6ff';
                }
            }
        },
        getLeftPos (target) {
            // 当前元素对应的绿点的坐标
            return {
                lx: target.offsetLeft + target.clientWidth,
                ly: target.offsetTop + target.clientHeight / 2
            }
        },
        getRightPos (target) {
            // 当前元素对应的绿点的坐标
            return {
                x: target.offsetLeft + target.parentNode.clientWidth,
                y: target.offsetTop + target.clientHeight / 2
            }
        },
        initData () {
            // 给每个小问添加原始数据
            this.pageAsk.canvas = {
                left: null,
                right: null,
                lineId: {}
            };
            this.pageAsk.equal = this.leftEqRight()
            this.resultArray = [];
            if (!this.onlyshow) {
                // 去掉其他线外选中样式
                let options = document.querySelectorAll('.line-option');
                for (let i = 0; i < options.length; i++) {
                    options[i].querySelector('.dot').style.backgroundColor = '#ccc';
                }
            }
        },
        initCanvas () {
            // 初始化canvas，将canvas设置为和父元素一样宽高
            let canvas = document.getElementById('canvas' + this.pageAsk.id + this.pageTag);
            let wrapDiv = document.getElementById('canvasWrap' + this.pageAsk.id + this.pageTag);
            canvas.setAttribute('height', wrapDiv.clientHeight);
            canvas.setAttribute('width', wrapDiv.clientWidth);
            this.pageAsk.height = wrapDiv.clientHeight;
            this.pageAsk.width = wrapDiv.clientWidth;
            // 初始化sheet（答案）表，将用户答案渲染上去
            if (this.sheet) {
                let answer = '';
                if (typeof this.sheet === 'object') {
                    answer = this.sheet.answer.split('|');
                } else {
                    answer = this.sheet.split('|')
                }
                let askId = this.pageAsk.id;
                answer.forEach((option) => {
                    let _option = option.split('-');
                    // this.chooseLeft(askId, _option[0]);
                    // this.chooseRight(askId, _option[1]);
                    this.chooseLeft({ askId: askId, index: Number(_option[1]) });
                    this.chooseRight({ askId: askId, id: Number(_option[0]) });
                })
            }
            // 如果是展示页面 在展示完后，加锁让所有不能点击
            this.onlyShowAnswer = this.onlyshow;
        }
    },
    mounted () {
        this.setOptionHeight();
        this.initCanvas()
    },
    created () {
        //console.log('英语连线')
        this.initData()
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

.line {
    padding-top: 30px / $ppr;
    color: #555;
}

.line-wrap {
    position: relative;
    z-index: 1;
    display: flex;
    canvas {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
    }
    .line-left,
    .line-right {
        width: 50%;
        position: relative;
        z-index: 2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        display: -webkit-flex;
        -webkit-flex-direction: column;
        -webkit-justify-content: center;
        > div:last-of-type {
            margin-bottom: 0;
        }
        img {
            max-width: 170px / $ppr;
            max-height: 128px / $ppr;
        }
    }
    .line-option {
        padding: 10px / $ppr;
        width: 180px / $ppr;
        min-height: 160px / $ppr;
        background-color: #fff;
        text-align: center;
        word-wrap: break-word;
        // word-break: break-word;
        position: relative;
        z-index: 1;
        border-radius: 16px / $ppr;
        vertical-align: top;
        margin-bottom: 24px / $ppr;
        font-size: 38px / $ppr;
        border: 1px / $ppr solid #ccc;
        line-height: 40px / $ppr;
        display: flex;
        justify-content: center;
        align-items: center;
        display: -webkit-flex;
        -webkit-justify-content: center;
        -webkit-align-items: center;
        // span {
        //   width: 200px/$ppr;
        //   height: 160px/$ppr;
        //   overflow-y: scroll;
        // }
        // &:after {
        //   content: '';
        //   height: 24px/$ppr;
        //   width: 24px/$ppr;
        //   border-radius: 50%;
        //   background-color: #5DD7FF;
        //   position: absolute;
        //   top: 50%;
        //   margin-top: -12px/$ppr;
        // }
        .dot {
            content: "";
            height: 24px / $ppr;
            width: 24px / $ppr;
            border-radius: 50%;
            // background-color: #5DD7FF;
            background-color: #ccc;
            position: absolute;
            top: 50%;
            margin-top: -12px / $ppr;
        }
    }
    .gray {
        width: 180px / $ppr;
        .dot {
            background-color: #ccc;
        }
    }
    .blue {
        width: 200px / $ppr;
        .dot {
            background: #5dd6ff;
        }
    }
    .inspect_myColor {
        width: 200px / $ppr;
        .dot {
            background: #5d89ef;
        }
    }
    .line-left {
        align-items: flex-start;
        .line-option {
            margin-left: 20px / $ppr;
            // &:after {
            //   right: -12px/$ppr;
            // }
            .dot {
                right: -12px / $ppr;
            }
        }
    }
    .line-right {
        align-items: flex-end;
        .line-option {
            margin-right: 20px / $ppr;
            // &:after {
            //   left: -12px/$ppr;
            // }
            .dot {
                left: -12px / $ppr;
            }
        }
    }
}
</style>
